import { Injectable, Injector } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './authentication.service';
import { CookieService } from './cookie-service.service';
import { SESSION_ID } from '../constants/authentication.constants';
import { WindowService } from './window.service';

@Injectable()
export class AppInsightsService {
  public user = '';
  public firmID = '';
  public sessionID = '';
  applicationInsights: ApplicationInsights;
  constructor(private injector: Injector, private windowService: WindowService) {
    this.applicationInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true, // option to log all route changes
      },
    });
    this.applicationInsights.loadAppInsights();
  }

  logPageView(name?: string, url?: string) {
    if (this.user === '' || this.firmID === '' || this.sessionID === '') {
      this.setupUser();
    }
    this.applicationInsights.trackPageView({
      name: name,
      uri: url,
      // isLoggedIn: this.authService.isLoggedIn,
      // properties: { user: this.authService.getInitials() },
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }) {
    if (this.user === '' || this.firmID === '' || this.sessionID === '') {
      this.setupUser();
    }
    this.applicationInsights.trackEvent({ name: name }, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }) {
    if (this.user === '' || this.firmID === '' || this.sessionID === '') {
      this.setupUser();
    }
    this.applicationInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number, properties?: { [key: string]: any }) {
    if (this.user === '' || this.firmID === '' || this.sessionID === '') {
      this.setupUser();
    }
    let telemetryItem: any = {};
    if (properties) {
      telemetryItem = {
        exception: exception,
        severityLevel: severityLevel,
        properties: properties,
      };
    } else {
      telemetryItem = {
        exception: exception,
        severityLevel: severityLevel,
      };
    }

    this.applicationInsights.trackException(telemetryItem);
  }

  logTrace(message: string, properties?: { [key: string]: any }) {
    if (this.user === '' || this.firmID === '' || this.sessionID === '') {
      this.setupUser();
    }
    this.applicationInsights.trackTrace({ message: message }, properties);
  }
  setupUser() {
    const authService = this.injector.get<AuthenticationService>(AuthenticationService);
    const cookieService = this.injector.get<CookieService>(CookieService);
    this.user = authService.getInitials();
    this.firmID = authService.getFirmId();
    this.sessionID = this.windowService.getSessionIdFromWindow();
    console.log(this.user, this.firmID);
    this.applicationInsights.setAuthenticatedUserContext(this.user, this.firmID, true);
    this.applicationInsights.addTelemetryInitializer((telemetryItem: any) => {
      if (!telemetryItem.baseData.properties) {
        telemetryItem.baseData.properties = {};
      }
      let details = authService.getUserDetails();
      // Add some custom properties for all telemetry items
      telemetryItem.baseData.properties['txDocs_FirmId'] = authService.getFirmId() || details.FirmId;
      telemetryItem.baseData.properties['txDocs_FirmGuid'] = details.FirmGuid;
      telemetryItem.baseData.properties['txDocs_Initials'] = authService.getInitials() || details.Initials;
      telemetryItem.baseData.properties['txDocs_UserName'] = details.UserName;
      telemetryItem.baseData.properties['txDocs_SessionId'] = this.sessionID;
      telemetryItem.baseData.properties['txDocs_AnywhereClientId'] = details.AnywhereClientId;
    });
  }
}
